import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { toast } from 'react-toastify';
import ButtonAction from '../Button.js/SaveButton';
import { useTranslation } from 'react-i18next';
import Loader from '../loader/loader';
import { sendRequest } from 'src/utils';

export default function ConfirmModal({
    loading,
    visible = false,
    setVisible,
    handleDelete,
    title,
    mesages,
    titleButtonConfirm = 'delete',
    typeButtonConfirm = 'delete',
    paramsApi = null,
    serviceApi = null,
    callBackFunct = () => null,
    closeCancle = false,
    canCloseOutSide = true
}) {
    const { t } = useTranslation();
    const [flagProcess, setFlagProcess] = React.useState(false);
    const flagRef = React.useRef(false);

    const handleConfirm = () => {
        if (flagRef.current === true) return;
        flagRef.current = true;
        setFlagProcess(true);
        sendRequest(serviceApi, paramsApi || [], actionResult, true, timeOutFunct, 40000);
    };
    const actionResult = (reqInfoMap, message) => {
        flagRef.current = false;
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            callBackFunct && callBackFunct();
        }
    };
    const timeOutFunct = (reqInfo) => {
        flagRef.current = false;
        setFlagProcess(false);
        toast.error(t('error.time_out'));
    };
    return (
        <div>
            <Dialog open={visible} onClose={() => canCloseOutSide && setVisible(false)} aria-labelledby="draggable-dialog-title">
                <Loader loading={loading || flagProcess} />
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {title ? t(title) : t('info')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>{mesages ? t(mesages) : t('message')}</DialogContentText>
                </DialogContent>
                <DialogActions style={{ padding: '12px 16px' }}>
                    {!closeCancle && (
                        <ButtonAction
                            title={t('cancel')}
                            onClick={() => setVisible(false)}
                            // variant="text"
                            color="error"
                            type="cancel"
                        />
                    )}

                    <ButtonAction
                        title={t(titleButtonConfirm)}
                        type={typeButtonConfirm}
                        onClick={handleDelete || handleConfirm}
                    />
                </DialogActions>
            </Dialog>
        </div>
    );
}
